export const formatVariantOptions = (variants: { uuid: string, value: string }[], productVariants: any[]) => {
    const formattedOptions: { [key: string]: string } = {};

    // Map to track which option positions have been used
    const usedPositions = new Set();

    // Process variants based on their position field from the API
    variants.forEach(selectedVariant => {
        const variantDetails = productVariants.find((v: any) => v.uuid === selectedVariant.uuid);
        if (variantDetails) {
            // Use the position directly from the API response
            const position = variantDetails.position;
            
            if (position > 0 && position <= 3) {
                usedPositions.add(position);
                formattedOptions[`option${position}`] = `${variantDetails.optionName}: ${selectedVariant.value}`;
            }
        }
    });

    return formattedOptions;
};